import Header from "../../home/Header"
import Footer from "../../Footer"

const Thank = () => {




  return (

    <>


      <Header></Header>




      <div className="bginer" style={{ paddingTop: "100px" }}>
        <div className='container bginer'>
          <div className="contact-hero-section pt-5 pb-0 container ">
            <div className="text-center">
              <div className="heading mb-3 conust">
                <button class="contact-btn">Thank You</button>
              </div>
              <h3 className="text-center bold-highl">
               Thankyou For <span className="highlight">Enquiry </span>
              </h3>
              <p className="contact-subtitle">
                For any <span className="highlight">inquiries, assistance, or feedback</span> related to your experience on <a className="highlight" href="https://hindusanjog.com/" >Hinduasanjog.com</a>

                </p>
                <p>
                feel free to reach out to us at <a className="highlight" href="mailto:hindusanjog@gmail.com">hindusanjog@gmail.com</a> , <a href="tel:8088010188" className="highlight">8088010188</a>.
              </p>


            </div>
          </div>
          <div className='container pb-5'>

            <p className="fs-6 text-center">Whether you're seeking support with your profile, need help navigating the platform, or have questions regarding our services, our dedicated team is here to help. We aim to provide you with the best matrimonial experience and will respond promptly to ensure all your needs are met. Your journey towards finding the perfect match is important to us, and we’re always available to assist you in any way we can.</p>

          </div>

        </div>
        <style>
          {
            ` 
      . @media (max-width: 767px) {
        .msekal{ width:100%;
        }
        
      }



      .holdre {
        display: block;
        width: 100%;
        padding: 9.5px 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: var(--bs-body-color);
        background-color: var(--bs-body-bg);
        background-clip: padding-box;
        border: var(--bs-border-width) solid var(--bs-border-color);
        appearance: none;
        border-radius: 15px;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      }


      .boxshadwe {
        padding: 0 0 0 0 !important;
      }


      @media (max-width: 767px) {
        .marginimge {
          display: none;
        }
      }

      .marginimge {
        margin-top: 0 !important;
            padding-left: 0px;
      }




      .jaatimg {
        height: 676px;
        width: 640px;
      }

      .xysla {
        padding-right: 66px;
      }

      .top-space {
        margin-top: 20px;
      }

      .bginer {
        background: white;

        .shadowja {
          box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.075) !important
        }

      }


      .mb-3{
      margin-bottom:5px !important;}

      .form-label {
        margin-bottom: 0px;
        color: black;
      }

      .contact-btn {
        background-color: #ffecec;
        /* light pink background */
        color: #e91e63;
        /* black text */
        border: none;
        /* no border */
        padding: 10px 20px;
        /* spacing inside button */
        border-radius: 8px;
        /* rounded corners */
        font-weight: 500;
        /* medium bold text */
        font-size: 16px;
        /* text size */
        cursor: pointer;
        /* cursor changes on hover */
      }

      .contact-hero-section {
        background-color: #fff;
        padding-top: 60px;
        padding-bottom: 60px;
      }

      .conust {
        font-size: 22px;
        font-weight: bold;
      }

      .bold-highl {
        font-weight: 500;
      }

      .contact-label {
        display: inline-block;
        background-color: #fce4ec;
        /* Light pink */
        color: #c2185b;
        /* Deep pink */
        font-size: 14px;
        padding: 5px 12px;
        border-radius: 5px;
        font-weight: 500;
      }



      .contact-title {
        font-size: 28px;
        font-weight: bold;
        color: #000;
      }

      .contact-title .highlight {
        color: #e91e63;
        /* Highlighted pink */

      }

      .highlight {
        font-weight: 800;
      }

      .contact-subtitle {
        font-size: 16px;
        color: #444;
        margin-top: 10px;
      }

      .contact-section {
        padding: 60px 0;
        background-color: #fff;
      }

      .contact-box {
        border-radius: 10px;
        background: white;

      }

      .sendre {
        font-size: 20px;
        font-weight: bold;
      }

      .contact-heading {
        color: #E53D5C;
        font-weight: 800;
      }

      .contact-text {
        color: #333;
        font-size: 15px;
      }

      .contact-list li {
        margin-bottom: 10px;
        font-size: 15px;
        color: #444;
        display: flex;
        align-items: center;
      }



      .info-box .info-title span {
        color: #E53D5C;
        font-weight: 800;
      }

      .info-box p {
        color: #555;
        font-size: 15px;
      }

      .enquiry-form-box {
        background: white;
        border-radius: 10px;
      }

      .enquiry-form-box h6 span {
        color: #E53D5C;
        font-weight: 800;
      }

      .lets {
        font-size: 27px;
        font-weight: bold;
      }

      . .enquiry-btn {
        background-color: #E53D5C;
        border: none;
        font-weight: 500;
        transition: background 0.3s ease;
      }

      .enquiry-btn:hover {
        background-color: #d63350;
      }

      .b `
          }
        </style>
      </div>



      <Footer></Footer>




    </>
  );
};

export default Thank;